import React from 'react';
import FormInitData from './FormInitData';
import './App.css';

function App() {
  return (
    <div className="App">
      <FormInitData /> {/* Utilisation du composant */}
    </div>
  );
}

export default App;
